import React, { FC } from 'react';
import { useParams } from 'react-router';
import Edit from 'components/document-templates/components/Edit';

const Screen: FC = () => {
  const { id } = useParams<{ id: string | undefined }>();
  return (
    <Edit
      templatesEntityName="client-templates"
      templatesEntityEndpoint={`client-templates?id=${id}`}
      templatesDropdownsEntityName="client-template-dropdowns"
      templatesDropdownsEntityEndpoint="client-templates/dropdown-options"
    />
  );
};

export default Screen;
